// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"b9ec5bb0","937":"4c2b7811"}[chunkId] + ".chunk.js";
};